<template>
  <div>
    <!-- Header -->
    <div class="config-section-header">
      <div class="config-section-header__left">
        <v-icon small class="mr-2" color="text_secondary">mdi-poll</v-icon>
        <span class="config-section-label">Configuração da tarja enquete</span>
      </div>
    </div>

    <!-- Settings -->
    <div class="sc-settings-list sc-settings-list--with-footer-gap">
      <!-- Position -->
      <div class="sc-settings-list__row">
        <div class="sc-settings-list__info">
          <v-icon small color="text_secondary" class="mr-2">mdi-arrow-left-right</v-icon>
          <span class="sc-settings-list__name">Posição da enquete na tarja</span>
        </div>
        <v-select
          outlined dense solo flat hide-details
          v-model="selectedTarjaPosition"
          :items="tarjaPositionOptions"
          placeholder="Selecione"
          class="te-select"
        />
      </div>

      <!-- Bar mode -->
      <div class="sc-settings-list__row">
        <div class="sc-settings-list__info">
          <v-icon small color="text_secondary" class="mr-2">mdi-chart-bar</v-icon>
          <span class="sc-settings-list__name">Modo de exibição das barras</span>
        </div>
        <v-select
          outlined dense solo flat hide-details
          v-model="selectedBarraMode"
          :items="barraModes"
          placeholder="Selecione"
          class="te-select"
        />
      </div>

      <!-- Confirm button toggle -->
      <div class="sc-settings-list__row">
        <div class="sc-settings-list__info">
          <v-icon small color="text_secondary" class="mr-2">mdi-gesture-tap</v-icon>
          <div class="sc-settings-list__text">
            <span class="sc-settings-list__name">Botão de confirmação</span>
            <span class="sc-settings-list__desc">Exibir confirmação ao clicar em exibir/remover tarja</span>
          </div>
        </div>
        <v-switch
          v-model="flg_botao_confirmar_exibicao_tarja"
          color="primary" hide-details dense
          class="mt-0 pt-0"
        />
      </div>

      <!-- Hide title toggle -->
      <div class="sc-settings-list__row">
        <div class="sc-settings-list__info">
          <v-icon small color="text_secondary" class="mr-2">mdi-eye-off</v-icon>
          <div class="sc-settings-list__text">
            <span class="sc-settings-list__name">Ocultar título da enquete</span>
            <span class="sc-settings-list__desc">Esconder o título na exibição da tarja</span>
          </div>
        </div>
        <v-switch
          v-model="flg_ocultar_title_enquete"
          color="primary" hide-details dense
          class="mt-0 pt-0"
        />
      </div>

      <!-- Hide option names toggle -->
      <div class="sc-settings-list__row">
        <div class="sc-settings-list__info">
          <v-icon small color="text_secondary" class="mr-2">mdi-format-text-variant-outline</v-icon>
          <div class="sc-settings-list__text">
            <span class="sc-settings-list__name">Ocultar nome das opções</span>
            <span class="sc-settings-list__desc">Exibir apenas as imagens das opções (enquetes com emojis/imagens)</span>
          </div>
        </div>
        <v-switch
          v-model="flg_ocultar_nome_opcoes"
          color="primary" hide-details dense
          class="mt-0 pt-0"
        />
      </div>

      <!-- Chroma color -->
      <div class="sc-settings-list__row">
        <div class="sc-settings-list__info">
          <v-icon small color="text_secondary" class="mr-2">mdi-palette</v-icon>
          <span class="sc-settings-list__name">Cor de background do chroma</span>
        </div>
        <v-menu
          :close-on-content-click="false"
          transition="scale-transition"
          v-model="isColorPickerOpen"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <div class="action-box color-box" v-bind="attrs" v-on="on">
              <div class="color-preview" :style="{ backgroundColor: chromaColorHex }"></div>
              <span class="action-label">Chroma</span>
            </div>
          </template>
          <v-card class="color-picker-card">
            <v-card-text class="pa-3">
              <v-color-picker
                v-model="cor_background_chroma_tarja"
                dot-size="20"
                swatches-max-height="200"
                hide-inputs hide-mode-switch
                mode="hexa"
              />
              <div class="color-preview-bar mt-3" :style="{ backgroundColor: chromaColorHex }">
                {{ chromaColorHex }}
              </div>
              <div class="color-actions mt-3">
                <v-btn outlined small class="reset-btn" @click="resetChromaColor">
                  <v-icon small left>mdi-refresh</v-icon>
                  Resetar
                </v-btn>
                <v-btn color="primary" small class="save-btn" @click="isColorPickerOpen = false">
                  OK
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-menu>
      </div>
    </div>

    <!-- Save -->
    <div class="sc-modal__footer">
      <v-btn
        color="primary"
        @click.prevent="salvarConfigTarja"
        :loading="loadingSave"
        class="modal-btn-confirm"
      >
        <v-icon small class="mr-1">mdi-check</v-icon>
        Salvar
      </v-btn>
    </div>
  </div>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "EditarConfiguracoesTarjaEnquete",
  props: {
    cod_producao: Number,
  },
  data() {
    return {
      selectedTarjaPosition: null,
      selectedBarraMode: null,
      barraModes: ["Vertical", "Horizontal"],
      tarjaPositionOptions: ["Esquerda", "Centro", "Direita"],
      flg_botao_confirmar_exibicao_tarja: null,
      flg_ocultar_title_enquete: null,
      flg_ocultar_nome_opcoes: null,
      cor_background_chroma_tarja: { hexa: "#00FF00FF" },
      isColorPickerOpen: false,
      loadingSave: false,
    };
  },
  async created() {
    await this.getConfigTarjaEnquete({
      cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
    });
    if (this.configTarjaEnquete) {
      this.populateConfigTarja();
    }
  },
  computed: {
    ...mapGetters({
      configTarjaEnquete: "tarja_enquete/getConfigTarja",
    }),
    chromaColorHex() {
      if (!this.cor_background_chroma_tarja) return "#00FF00";
      return typeof this.cor_background_chroma_tarja === "object"
        ? this.cor_background_chroma_tarja.hex || this.cor_background_chroma_tarja.hexa
        : this.cor_background_chroma_tarja;
    },
  },
  methods: {
    ...mapActions({
      getConfigTarjaEnquete: "tarja_enquete/getConfigTarjaEnquete",
    }),
    resetChromaColor() {
      this.cor_background_chroma_tarja = { hexa: "#00FF00FF" };
    },
    populateConfigTarja() {
      const config = this.$store.state.tarja_enquete.configTarjaEnquete;
      if (!config) return;
      this.selectedTarjaPosition =
        config.dsc_posicao_tarja.charAt(0).toUpperCase() + config.dsc_posicao_tarja.slice(1);
      this.selectedBarraMode =
        config.dsc_orientacao_barra.charAt(0).toUpperCase() + config.dsc_orientacao_barra.slice(1);
      this.flg_botao_confirmar_exibicao_tarja = config.flg_botao_confirmar_exibicao;
      this.flg_ocultar_title_enquete = !config.flg_display_title;
      this.flg_ocultar_nome_opcoes = !config.flg_display_option_title;
      this.cor_background_chroma_tarja = { hexa: config.dsc_hex_background_chroma || "#00FF00FF" };
    },
    async salvarConfigTarja() {
      if (!this.selectedTarjaPosition) {
        this.$toast.info("Selecione a posição da tarja");
        return;
      }
      this.loadingSave = true;
      try {
        const chromaColor = typeof this.cor_background_chroma_tarja === "object"
          ? this.cor_background_chroma_tarja.hexa
          : this.cor_background_chroma_tarja;

        const payload = {
          dsc_posicao_tarja: this.selectedTarjaPosition.toLowerCase(),
          flg_botao_confirmar_exibicao: this.flg_botao_confirmar_exibicao_tarja ?? false,
          dsc_hex_background_chroma: chromaColor,
          flg_display_title: !this.flg_ocultar_title_enquete,
          flg_display_option_title: !this.flg_ocultar_nome_opcoes,
        };

        if (!this.configTarjaEnquete) {
          await apiClient.post(`createProducaoConfigTarjaEnquete/${this.cod_producao}`, payload);
          this.$toast.success("Configuração criada com sucesso.");
        } else {
          await apiClient.put(
            `updateProducaoConfigTarjaEnquete/${this.configTarjaEnquete.id}/${this.cod_producao}`,
            { ...payload, dsc_orientacao_barra: this.selectedBarraMode.toLowerCase() }
          );
          this.$toast.success("Configuração atualizada com sucesso.");
        }

        await this.getConfigTarjaEnquete({
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
        });
        this.populateConfigTarja();
      } catch (error) {
        this.$toast.error("Erro ao salvar configuração.");
      } finally {
        this.loadingSave = false;
      }
    },
  },
  watch: {
    "$store.state.producoes.selectedProducao": async function (newProducao) {
      if (!newProducao) return;
      await this.getConfigTarjaEnquete({ cod_producao: newProducao.cod_producao });
      if (this.configTarjaEnquete) {
        this.populateConfigTarja();
      }
    },
  },
};
</script>

<style lang="scss" scoped>

.te-select {
  max-width: 200px;
  flex-shrink: 0;
}


.color-box { border-style: solid; }

.color-preview {
  width: 28px;
  height: 28px;
  border-radius: var(--sc-radius-sm);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.color-picker-card { border-radius: var(--sc-radius-lg) !important; }

.color-preview-bar {
  height: 32px;
  border-radius: var(--sc-radius-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 0.8rem;
  font-weight: 500;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
}

.color-actions {
  display: flex;
  gap: 8px;
  .reset-btn { flex: 1; text-transform: none; letter-spacing: 0; }
  .save-btn { flex: 1; text-transform: none; letter-spacing: 0; }
}

/* Switch overrides */
::v-deep .v-input--switch { margin: 0; padding: 0; }
::v-deep .v-input--switch__track { opacity: 0.3; }
</style>
